// src/shared/location/locationJsonService.ts

import {
  Country as NamedCountry,
  State as NamedState,
  City as NamedCity,
} from "country-state-city";
import * as CSC from "country-state-city";

const Country =
  NamedCountry || (CSC as any)?.Country || (CSC as any)?.default?.Country;
const State =
  NamedState || (CSC as any)?.State || (CSC as any)?.default?.State;
const City =
  NamedCity || (CSC as any)?.City || (CSC as any)?.default?.City;

export type LocationOption = {
  value: string;
  label: string;
};

const extraData: Record<
  string,
  {
    states: string[];
    cities: Record<string, string[]>;
  }
> = {
  WS: {
    states: ["UPOLU", "VAIMAUGA_4"],
    cities: {
      UPOLU: ["APIA"],
      VAIMAUGA_4: ["Savalalo"],
    },
  },
};

export const locationJsonService = {
  getCountries(): LocationOption[] {
    const countryData = Country?.getAllCountries?.() || [];
    return countryData.map(({ name, isoCode }: any) => ({
      label: name === "United States" ? "United States of America" : name,
      value: isoCode,
    }));
  },

  getStatesByCountry(countryShortName: string): LocationOption[] {
    const existingStates = (
      State?.getStatesOfCountry?.(countryShortName) || []
    ).map((s: any) => s.name);
    const extraStates = extraData[countryShortName]?.states || [];

    const allStates = [...existingStates, ...extraStates];
    return allStates.map((stateName) => ({
      value: stateName,
      label: stateName,
    }));
  },

  getCitiesByState(
    countryShortName: string,
    stateName: string
  ): LocationOption[] {
    const states = State?.getStatesOfCountry?.(countryShortName) || [];
    const state = states.find((s: any) => s.name === stateName);

    let existingCities: string[] = [];
    if (state) {
      existingCities = (
        City?.getCitiesOfState?.(countryShortName, state.isoCode) || []
      ).map((c: any) => c.name);
    }

    const extraCities = extraData[countryShortName]?.cities?.[stateName] || [];

    const allCities = [...existingCities, ...extraCities];
    return allCities.map((cityName) => ({
      value: cityName,
      label: cityName,
    }));
  },
};
